var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#387"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 24l-10.5 6.062V17.938L30 24z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NyIgaGVpZ2h0PSI0NyIgdmlld0JveD0iMCAwIDQ3IDQ3IiBmaWxsPSJub25lIj4KICAgIDxjaXJjbGUgY3g9IjIzLjUiIGN5PSIyMy41IiByPSIyMy41IiBmaWxsPSIjMzM4ODc3Ii8+CiAgICA8cGF0aCBkPSJNMzAgMjRMMTkuNSAzMC4wNjIyTDE5LjUgMTcuOTM3OEwzMCAyNFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==";
export { SvgVideoIcon as ReactComponent };